import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../lib/cn.js';
export const Kbd = forwardRef(function Kbd({ className, children, ...rest }, ref) {
    return (_jsx("kbd", { ref: ref, ...rest, className: cn('inline-flex items-center rounded-1 border border-[var(--color-line-2)] px-1.5 py-px font-mono text-2xs text-[var(--color-ink-muted)]', className), children: children }));
});
